export const ALL = 1;
export const FAVOURITE = 2;
export const SPORT = 3;
export const LEAGUE = 4;
export const MATCH = 5;
export const TIMETABLE = 6;


// WEBPACK FOOTER //
// ./js/constants/DisplayMode.js